import React from 'react';
import { motion } from 'framer-motion';

/** Sanfte Einblendung beim Scrollen, einmalig. */
const prefersStatic = () =>
  typeof window !== 'undefined' &&
  ((navigator as any).webdriver === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches);

export const Reveal: React.FC<{ children: React.ReactNode; delay?: number; className?: string }> = ({
  children, delay = 0, className,
}) => {
  if (prefersStatic()) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -40px 0px' }}
      transition={{ duration: 0.6, delay, ease: [0.2, 0.7, 0.2, 1] }}
    >
      {children}
    </motion.div>
  );
};

/** Zeilenumbrüche aus dem CMS ("\n") als <br> rendern. */
export const Lines: React.FC<{ text: string }> = ({ text }) => (
  <>
    {(text || '').split('\n').map((line, i, arr) => (
      <React.Fragment key={i}>
        {line}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ))}
  </>
);

export const SectionHeader: React.FC<{ eyebrow: string; title: string; intro?: string; align?: 'left' | 'center' }> = ({
  eyebrow, title, intro, align = 'left',
}) => (
  <Reveal className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}>
    <p className="eyebrow mb-4">{eyebrow}</p>
    <h2 className="display-lg"><Lines text={title} /></h2>
    {intro && <p className="lede mt-5 max-w-2xl">{intro}</p>}
  </Reveal>
);

export const Check: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 20 20" fill="none" className={className || 'h-5 w-5'} aria-hidden>
    <circle cx="10" cy="10" r="9" className="fill-accent/15" />
    <path d="M6.5 10.5l2.3 2.3L13.8 8" stroke="#3fced1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Arrow: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 20 20" fill="none" className={className || 'h-4 w-4'} aria-hidden>
    <path d="M4 10h11m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
